import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ContractRequestRule, GetChangeTypeResponseModel } from 'src/app/shared/lib/contract-request/models';
import { ValidationRuleInvocationDto } from 'src/app/shared/lib/validations/models/validation-rule-invocation-return.model';
import { FacilityContractStatus, MarginCalculatorModel } from '../../models';
import { MarginContract } from '../../models/margin-contract.model';

export const ReviewAndSendActions = createActionGroup({
    source: 'Margin Calculator Update - Review And Send Margin',
    events: {
        /** Review and send */
        reviewAndSendClicked: emptyProps(),
        getContractRequestCount: emptyProps(),
        reviewAndSendMargin: emptyProps(),
        existingContractRequestDialogCanceled: emptyProps(),
        postSaveMargin: emptyProps(),
        loadContractStatusAndChangeType: props<{
            facilityId: number;
            marginId: number;
            userId: number;
        }>(),
        loadContractStatusAndChangeTypeSuccess: props<{
            marginId: number;
            contractStatusForFacility: FacilityContractStatus;
            changeType: GetChangeTypeResponseModel;
        }>(),
        saveValidation: props<{
            marginId: number;
            contractStatusForFacility: FacilityContractStatus;
            changeType: GetChangeTypeResponseModel;
        }>(),
        saveValidationSuccess: props<{
            marginId: number;
        }>(),
        validationSuccess: props<{ marginId: number }>(),
        facilityContractInGoodStanding: emptyProps(),
        loadUpdatedValidationsSuccess: props<{
            validations: ValidationRuleInvocationDto[];
        }>(),
        reviewAndSendMarginSuccess: props<{ contractId: number }>(),
        reviewAndSendMarginFail: props<{ message: string }>(),
        reviewAndSendMarginBlockedByViolations: props<{ message: string }>(),
        /** Create contract request - part of review and send */
        addContractRequest: props<{
            rules: ContractRequestRule[];
            marginId: number;
            marginPct: number;
            recruiterId: number;
            facilityId: number;
        }>(),
        createContractRequest: emptyProps(),
        createContractRequestSuccess: props<{ contractRequestId: number; marginId: number }>(),
        createContractRequestFail: props<{ message: string }>()
    }
});

export const PipelineMarginActions = createActionGroup({
    source: 'Margin Calculator Update - Pipeline Margin',
    events: {
        pipelineMargin: emptyProps(),
        /** Pipeline margin after it's saved */
        pipelineMarginAfterSave: props<{ marginId: number }>(),
        pipelineMarginSuccess: props<{ marginContract: MarginContract }>(),
        pipelineMarginFail: props<{ message: string }>()
    }
});

export const DuplicateMarginActions = createActionGroup({
    source: 'Margin Calculator Update - Duplicate Margin',
    events: {
        duplicateMargin: props<{ jobId: number }>(),
        duplicateMarginSuccess: props<{ marginId: number }>(),
        duplicateMarginFail: props<{ message: string }>()
    }
});

export const ValidateFormActions = createActionGroup({
    source: 'Margin Calculator Update - Validate Form',
    events: {
        /** Validate form group */
        validateFormBeforeSaveSuccess: props<{ margin: MarginCalculatorModel }>(),
        validateFormBeforeSaveFail: props<{ message: string }>()
    }
});

export const UpdateMarginActions = createActionGroup({
    source: 'Margin Calculator Update',
    events: {
        saveClicked: emptyProps(),
        showWfdDialog: emptyProps(),
        saveConfirmed: emptyProps(),
        saveMargin: emptyProps(),
        saveMarginSuccess: props<{ marginId: number }>(),
        saveMarginFail: props<{ message: string }>(),
        /** Common "save margin" action. Should be called from the effect. */
        saveMarginCommon: emptyProps(),
        saveMarginCommonSuccess: props<{ marginId: number }>(),
        saveMarginCommonFail: props<{ message: string }>(),
        /** Reset the status of the update action */
        resetUpdateStatus: emptyProps(),
        saveConfirmedFailed: emptyProps()
    }
});
